<template>
    <div class="content-body">
        <div class="container pd-x-0">
            <div class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                <div>
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb breadcrumb-style1 mg-b-10">
                            <!--                            <li class="breadcrumb-item"><a href="#">Dashboard</a></li>-->
                            <!--                            <li class="breadcrumb-item active" aria-current="page">Sales Monitoring</li>-->
                        </ol>
                    </nav>
                    <h4 class="mg-b-0 tx-spacing--1">Welcome
                        <span v-if="system.userInfo != null">
                            {{system.userInfo.firstName}}
                        </span></h4>
                </div>
                <div class="d-none d-md-block">
                    <new-account-button></new-account-button>
                    <router-link to="/new-officer" class="btn btn-sm pd-x-15 btn-white btn-uppercase mg-l-5"><i data-feather="plus" class="wd-10 mg-r-5"></i> New Officer</router-link>
                    <button style="background-color: #6d0606; border-color: #6d0606;" class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5">
                        <download-excel
                                class   = "lnr-cloud-download"
                                style="cursor: pointer;"
                                :data   = "disputes"
                                worksheet = "My Worksheet"
                                :name    = "$route.name+'.xls'">
                            <span> <i data-feather="file" class="wd-10 mg-r-5"></i> Generate Report</span>
                        </download-excel>
                    </button>
                </div>
            </div>

            <!--TODO TOP CARDS-->
            <top-cards></top-cards>
            <!--TODO GROWTH-->
            <div class="row">
                <div class="col-md-12 mg-t-10">
                    <div class="card ht-100p">
                        <div class="card-header d-flex align-items-center justify-content-between">
                            <h6 class="mg-b-0">Officers <i data-feather="chevrons-right" class="wd-10 mg-r-5"></i></h6>
                            <div class="d-flex tx-18">
                                <a href="" class="link-03 lh-0"><i class="icon ion-md-refresh"></i></a>
                                <router-link to="/new-officer" class="link-03 lh-0 mg-l-10"><i class="icon ion-md-add"></i></router-link>
                            </div>
                        </div>
                        <base-table
                                :items="disputes"
                                :fields="fields"
                                :show-title="true"
                                :is-busy="dispute.disputeLoading"
                                class="mt-2"
                        ></base-table>
                    </div>
                </div>
            </div>


        </div><!-- container -->
    </div>
</template>

<script>
    import TopCards from "../../components/card/TopCards";
    import BaseTable from "../../components/table/BaseTable";
    import NewAccountButton from "../../components/button/NewAccountButton";
    import {mapState} from 'vuex';

    export default {
        name: 'Home',
        components:{
            TopCards,
            BaseTable,
            NewAccountButton
        },
        data(){
            return{
                fields: [
                    { key: 'serial', label: 'S/N', sortable: true, sortDirection: 'desc' },
                    { key: 'disputeCreatedAt', label: 'LoggedAt', sortable: true, sortDirection: 'desc' },
                    // { key: 'disputeUpdatedAt', label: 'UpdatedAt', sortable: true, sortDirection: 'desc' },
                    { key: 'disputeSessionId', label: 'SessionId', sortable: true, sortDirection: 'desc' },
                    { key: 'disputeTrnType', label: 'TransactionType', sortable: true, class: 'text-left' },
                    { key: 'disputeIssueType', label: 'Issue', sortable: true, class: 'text-left' },
                    { key: 'comment', label: 'Comment', sortable: true, class: 'text-left' },
                    { key: 'remark', label: 'Remark', sortable: true, class: 'text-left' },
                    { key: 'disputeStatus', label: 'Status', sortable: true, class: 'text-left' },
                    { key: 'actions', label: 'Action', sortable: true, class: 'text-left' }
                ],
            }
        },
        computed:{
            ...mapState([
                'officer',
                'dispute',
                'system',
            ]),

            disputes:{
                get(){
                    return this.dispute.disputes
                },
                set(val){
                    this.$store.commit('dispute/updateDisputes', val)
                }
            },
        },
        methods:{
            async readDisputes(){
                await this.$store.dispatch("dispute/updateDisputes", {
                    disputeOrgId: localStorage.orgID,
                    readAll: "NO"
                }, {root: true})
            },
            navigate(){
                this.$router.push("/dashboard/dispute-new")
            },
            navigate2(_item){
                localStorage.suAccID = this.company.account[0].accID
                localStorage.suOfficerID = _item
                this.$router.push("/terminal/officer-admin-details")
            },
            async changeStatusDef(_id, _orgId, _remark, _type){
                await this.$store.dispatch("dispute/reOpenDispute",
                    {
                        disputeId: _id,
                        disputeOrgId: _orgId,
                        disputeRemark: _remark,
                        disputeStatus: _type
                    },
                    {
                        root: true
                    })
                this.readDisputes()
            },
            reOpenDispute(_id, _orgId, _remark, _type){
                const options = {title: 'Confirmation', size: 'sm', okLabel: 'Yes, reopen it!'};
                this.$dialogs.alert('Kindly confirm reopening dispute!', options)
                    .then(res => {
                        if (res.ok)
                            this.changeStatusDef(_id, _orgId, _remark, _type)
                        //console.log(res) // {ok: true|false|undefined}
                    });
            }
        },
        mounted() {
            this.readDisputes()
        }
    }
</script>
